/**
 * 判断默认路由是否有权限,没有权限默认跳转到第一个有权限的路由，否则404,子系统需配置有404路由
 */
import { useNavigate } from 'react-router-dom';
const transformPath = (path) => {
    return path.startsWith('/') ? path : `/${path}`;
};
const getListChildrenFirst = (resources) => {
    if (resources.children && resources.children.length > 0) {
        return getListChildrenFirst(resources.children[0]);
    }
    return resources.key;
};
export function useFirstPermissionRouter({ routes, systemId, }) {
    const navigate = useNavigate();
    const navigatorToPath = (path) => {
        navigate(transformPath(path + window.location.search));
    };
    const setFirstPerRouter = (resourceList) => {
        if (!systemId) {
            return;
        }
        if (sessionStorage.getItem('__init') === 'true') {
            return;
        }
        sessionStorage.setItem('__init', 'true');
        if (resourceList.length === 0) {
            navigate('/404');
            return;
        }
        const defalutRouter = routes[0];
        if (defalutRouter && defalutRouter.element.props.to) {
            const pathTo = defalutRouter.element.props.to;
            const keywords = ['purchase', 'supplier'];
            const containsKeyword = keywords.some((keyword) => pathTo.includes(keyword));
            const permissionObj = resourceList.find((item) => (pathTo + '').includes(item.key));
            // 如果完全匹配
            if (containsKeyword) {
                const locationSystem = window.location.pathname.split('/')[1];
                const pathToName = `/${locationSystem}${permissionObj.key}`;
                if (permissionObj && pathToName === pathTo) {
                    return;
                }
            }
            if (permissionObj && permissionObj.key === pathTo) {
                return;
            }
            // 有第一个选项路由
            if (permissionObj && permissionObj.children?.length > 0) {
                // 查找完全匹配的
                const permissionChildrenObj = permissionObj.children.find((item) => item.key === pathTo);
                if (permissionChildrenObj) {
                    return;
                }
                else {
                    const path = getListChildrenFirst(permissionObj.children[0]);
                    navigatorToPath(path);
                }
            }
            else {
                if (resourceList.length > 0) {
                    const firstRouter = resourceList[0];
                    const path = getListChildrenFirst(firstRouter);
                    navigatorToPath(path);
                }
                else {
                    navigatorToPath('/404');
                }
            }
        }
    };
    return {
        setFirstPerRouter,
    };
}
